import React from 'react';
import styles from '../../../styles/ListingManagement.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';
import type { ListingImageType } from '../../../types/ListingTypes';

const IMAGE_TYPES: ListingImageType[] = [
  'Bedroom', 'Bathroom', 'Kitchen', 'Patio', 'Garden', 'Front', 'Back', 'Scullery', 'Garage',
];

interface Props {
  onClose: () => void;
  imageTag: ListingImageType;
  onImageTagChange: (tag: ListingImageType) => void;
  file: File | null;
  onFileChange: (file: File | null) => void;
  uploading: boolean;
  error: string | null;
  onUpload: () => void;
}

const AddImageModal: React.FC<Props> = ({
  onClose, imageTag, onImageTagChange, file, onFileChange, uploading, error, onUpload,
}) => (
  <div
    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
    onClick={onClose}
  >
    <div
      style={{ background: '#fff', borderRadius: 10, padding: 28, width: 420, maxWidth: '92vw', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}
      onClick={e => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}>Add Image</h4>
        <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', lineHeight: 1, cursor: 'pointer', color: '#6c757d' }}>×</button>
      </div>

      {error && <p className={styles.agreementFormError}>{error}</p>}

      <div className={styles.categoryRow}>
        <label className={styles.categoryLabel}>Image Type</label>
        <div className={styles.categoryInputWrapper} style={{ width: 'fit-content' }}>
          <select
            className={styles.categoryInput}
            value={imageTag}
            onChange={e => onImageTagChange(e.target.value as ListingImageType)}
          >
            {IMAGE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div className={styles.categoryRow}>
        <label className={styles.categoryLabel}>File</label>
        <div className={styles.categoryInputWrapper} style={{ overflow: 'hidden' }}>
          <input
            type="file"
            accept="image/*"
            className={styles.categoryInput}
            style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
            onChange={e => onFileChange(e.target.files?.[0] ?? null)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 }}>
        <button type="button" className={`${buttonStyles.button} ${buttonStyles.secondary}`} onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className={`${buttonStyles.button} ${buttonStyles.primary}`}
          disabled={!file || uploading}
          onClick={onUpload}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </div>
    </div>
  </div>
);

export default AddImageModal;
